import { IDB_processFlowsWrite } from '../IDB/IDB.table.processFlow'
import { Imag_cacheImages } from '../Imag/Imag.cache'
import { Imag_getImageUrlsForPf } from '../Imag/Imag.getUrls'
import { Serv_send } from '../Serv/Serv.socketClient'

export async function Sync_syncProcessFlow(since: number) {
    const results = await Serv_send('v2.processFlow.getAll', { since })

    await IDB_processFlowsWrite(results.processFlows)

    Imag_cacheImages(Imag_getImageUrlsForPf(results.processFlows))
}
